import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@env';
import { AuthService } from '@app/core/auth/auth.service';

/**
 * Ajoute en une seule fois les headers requis par le back sur les appels à
 * l'API SmartPlanner : la clé de souscription APIM, et le JWT applicatif
 * (`x-profile-token`, cf. `AuthService.loadProfile`) qui permet au back de
 * vérifier le profil de l'utilisateur, et le code de sa filiale active. Ces
 * headers ne sont présents que si un profil a déjà été résolu.
 */
export const apiHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiConfig.uri)) {
    return next(req);
  }

  const authService = inject(AuthService);
  const profileToken = authService.profileToken();
  const activeSubsidiary = authService.activeSubsidiary();
  const cloned = req.clone({
    setHeaders: {
      'Ocp-Apim-Subscription-Key': environment.apiConfig.subscriptionKey,
      ...(profileToken ? { 'x-profile-token': profileToken } : {}),
      ...(activeSubsidiary?.codeOkapi ? { 'x-subsidiary-code': activeSubsidiary.codeOkapi } : {}),
    },
  });
  return next(cloned);
};
